import { NzUploadFile } from 'ng-zorro-antd/upload';
import { resolveFileUrl } from './resolve-url';

export function toUploadFileList(fileNames: string[]): NzUploadFile[] {
    if (!fileNames) return [];
    let i = -1;
    return fileNames.map(fn => <NzUploadFile>{ name: fn, url: resolveFileUrl(fn), status: "done", uid: `${i--}`, thumbUrl: resolveFileUrl(fn) })
}
